export default __webpack_public_path__ + "4c6463f3d0b4a44855ee51369b528324.png";